import type { ReactNode } from 'react'
import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'

type Props = {
  label: string
  value: ReactNode
}

export function StatCard({ label, value }: Props) {
  return (
    <div className="flex flex-col justify-between gap-10 p-5">
      <div className="flex flex-row items-center gap-2">
        <GraphIcon className="text-foreground shrink-0" />
        <span className="text-base font-semibold text-foreground">{label}</span>
      </div>
      <span className="text-[32px] font-semibold text-foreground self-end">
        {value}
      </span>
    </div>
  )
}
